import { HomepageHeroVideo } from "./HomepageHeroVideo";

export const UniversalRender = HomepageHeroVideo;
